import { connect } from 'react-redux';

import { bindRtkActionToPromise } from 'app/utils/promiseActions';

import { websocketActions } from '../../../app/middleware/websocket/actions/websocket';
import { timelineActions } from '../actions/timeline';
import { Timeline } from '../components/Timeline';
import {
  getConversationTimeline,
  getCurrentConversationId,
} from '../selectors';

const mapStateToProps = (state) => {
  return {
    isLoading: state.timeline.asyncStatus === 'loading',
    isFailed: state.timeline.asyncStatus === 'failed',
    timelineData: getConversationTimeline(state),
    currentConversationId: getCurrentConversationId(state),
    requesterId: state.timeline.currentRequesterId,
    granularity: state.timeline.granularity,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getTimeline: (payload) =>
      dispatch(timelineActions.timelineGetRequest(payload)),
    timelineClear: () => dispatch(timelineActions.timelineClear()),
    wsRequest: bindRtkActionToPromise(dispatch, websocketActions.request),
  };
};

export type StateProps = ReturnType<typeof mapStateToProps>;
export type DispatchProps = ReturnType<typeof mapDispatchToProps>;

export default connect(mapStateToProps, mapDispatchToProps)(Timeline);
